module.exports = __webpack_public_path__ + "static/img/ic_btn_add@2x.c39bcbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finds/ic_btn_add@2x.png
// module id = 3ZL5
// module chunks = 1